import styled from "./navbar.module.css"
import {Link} from "react-router-dom"
function Navbar(probs) {

    return(
    <div className={styled.headerWraper}>
    <div className="container">
    <div className={styled.header}>
        <h3>{probs.title}</h3>
       <ul>
        <li>
            <Link to="/about">
            درباره
            </Link> 

        </li>
        <li>
        <Link to="/create-article">  مقاله جدید</Link> 
         </li>
        <li>
            <Link to="/">
            لیست مقالات
            </Link>
        </li>
       </ul>
       </div>
 </div>
    </div>
    );
}
export default Navbar